import Api from '@/services/Api'

export default {
    getCodigoCompania(idCompania){
        return Api().get('getCodigoCompania/'+idCompania)
    },
    getNotasEF(codReporte,idCompania,vigencia,clase){
        return Api().get('getNotasEF/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+clase)
    },
    getNotas(codReporte,idCompania,vigencia,numero){
        return Api().get('getNotas/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+numero)
    },
    getTodasNotas(codReporte,idCompania,vigencia){
        return Api().get('getTodasNotas/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    leeTasas(vigencia){
        return Api().get('leeTasas/'+vigencia)
    },
    getBalanceNiif(codReporte,idCompania,vigencia){
        return Api().get('balanceNiif/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getBalanceNiifConsol(codReporte,vigencia,empresas){
        return Api().get('balanceNiifConsol/'+codReporte+'/'+vigencia+'/'+empresas)
    },
    getBalanceNiifGrupos(codReporte, vigencia, grupos) {
        return Api().get('balanceNiifGrupos/' + codReporte + '/' + vigencia + '/' + grupos)
    },
    getReporteEsfGrupos(codReporte, grupos, vigencia) {
        return Api().get('ReporteEsfGrupos/' + codReporte + '/' + grupos + '/' + vigencia)
    },
    getReporteEriGrupos(codReporte, grupos, vigencia) {
        return Api().get('ReporteEriGrupos/' + codReporte + '/' + grupos + '/' + vigencia)
    },
    getBalanceNiifCompar(codReporte,idCompania,vigencia){
        return Api().get('balanceNiifCompar/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getCompanias(individual){
        return Api().get('getCompanias/'+individual)
    },
    getFechas(){
        return Api().get('getFechas')
    },
    getReportes(){
        return Api().get('getReportes')
    },
    getReporteEsf(codReporte,idCompania,vigencia){
        return Api().get('ReporteEsf/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEsfConsol(codReporte,empresas,vigencia){
        return Api().get('ReporteEsfConsol/'+codReporte+'/'+empresas+'/'+vigencia)
    },
    getReporteEsfCompar(codReporte,idCompania,vigencia){
        return Api().get('ReporteEsfCompar/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEri(codReporte,idCompania,vigencia){
        return Api().get('ReporteEri/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEriConsol(codReporte,empresas,vigencia){
        return Api().get('ReporteEriConsol/'+codReporte+'/'+empresas+'/'+vigencia)
    },
    getReporteEriCompar(codReporte,idCompania,vigencia){
        return Api().get('ReporteEriCompar/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEfe(idCompania,vigencia,codReporte){
        return Api().get('ReporteEfe/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEfeDirecto(empresas,vigencia,codReporte,nivel,consolidado){
        return Api().get('ReporteEfeDirecto/'+empresas+'/'+vigencia+'/'+codReporte+'/'+nivel+'/'+consolidado)
    },
    getReporteEfeIndirecto(empresas,vigencia,codReporte,nivel,consolidado){
        return Api().get('ReporteEfeIndirecto/'+empresas+'/'+vigencia+'/'+codReporte+'/'+nivel+'/'+consolidado)
    },
    getReporteInformacion(idCompania,vigencia,codReporte,directo,u_crea){
        return Api().get('ReporteInformacion/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+directo+'/'+u_crea)
    },
    getReporteEcpInformacion(idCompania,vigencia,codReporte,u_crea){
        return Api().get('ReporteEcpInformacion/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+u_crea)
    },
    getReporteEcpInformacionConsol(idCompania,vigencia,codReporte,u_crea){
        return Api().get('ReporteEcpInformacionConsol/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+u_crea)
    },
    grabaEcpInformacionConsol(idCompania, vigencia, codReporte, form) {
        return Api().post('GrabaEcpInformacionConsol/' + idCompania + '/' + vigencia + '/' + codReporte, form)
    },
    grabaInformacion(idCompania,vigencia,codReporte,form){
        console.log(form)
        return Api().post('GrabaInformacion/'+idCompania+'/'+vigencia+'/'+codReporte,form)
    },
    grabaEcpInformacion(idCompania,vigencia,codReporte,form){
        return Api().post('GrabaEcpInformacion/'+idCompania+'/'+vigencia+'/'+codReporte,form)
    },
    getReporteEcp(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcp/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpConsol(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpConsol/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpCompar(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpCompar/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpFinal(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpFinal/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpFinalConsol(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpFinalConsol/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getEliminaciones(codReporte,vigencia,opcion){
        return Api().get('getEliminaciones/'+codReporte+'/'+vigencia+'/'+opcion)
    },
    getEliminaOrigen(vigencia,secuencia,codReporte){
        return Api().get('getEliminaOrigen/'+vigencia+'/'+secuencia+'/'+codReporte)
    },
    getEliminaDestino(vigencia,secuencia,codReporte){
        return Api().get('getEliminaDestino/'+vigencia+'/'+secuencia+'/'+codReporte)
    },
    grabeAjuste(tabla,form){
        return Api().post('grabeAjuste/'+tabla, form)
    },
    elimineAjuste(tabla,form){
        return Api().post('elimineAjuste/'+tabla, form)
    },
    getValorAjustar(codReporte,vigencia,secuencia){
        return Api().get('getValorAjustar/'+codReporte+'/'+vigencia+"/"+secuencia)
    },
    grabeContraAjuste(form){
        return Api().post('grabeContraAjuste', form)
    },
    getAjustesTopside(idCompania,vigencia,codReporte,tipo_ajuste){
        return Api().get('getAjustesTopside/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+tipo_ajuste)
    },
    getCuentas(idCompania,vigencia){
        return Api().get('getCuentas/'+idCompania+'/'+vigencia)
    },
    getCuentasNiif(codReporte,idCompania,vigencia,niif){
        return Api().get('getCuentasNiif/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+niif)
    },
    getNiif(vigencia,idCompania){
        return Api().get('getNiif/'+idCompania+'/'+vigencia)
    },
    getSaldoNiif(idCompania,vigencia,cuenta,niif){
        return Api().get('getSaldoNiif/'+idCompania+'/'+vigencia+'/'+cuenta+'/'+niif)
    },
    grabeAjusteTopside(idCompania,vigencia,form){
        return Api().post('grabeAjusteTopside/'+idCompania+'/'+vigencia, form)
    },
    borraAjusteTopside(idCompania,vigencia,secuencia,tipo_ajuste){
        return Api().post('borraAjusteTopside/'+idCompania+'/'+vigencia+'/'+secuencia+'/'+tipo_ajuste)
    },
    getEcpFilas(){
        return Api().get('getEcpFilas')
    },
    getEcpColumnas(){
        return Api().get('getEcpColumnas')
    },
    ingresaElimAjusteOrig(dataOrig){
        return Api().post('insertElimAjusteOrig',dataOrig)
    },
    ingresaElimAjusteDest(dataOrig){
        return Api().post('insertElimAjusteDest',dataOrig)
    },
    getTBA(codReporte,idCompania,vigencia,numero,parrafo){
        return Api().get('getTBA'+'/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTBT(codReporte,idCompania,vigencia,numero,parrafo){
        return Api().get('getTBT'+'/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTBC(codReporte,idCompania,vigencia,numero,parrafo){
        return Api().get('getTBC'+'/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTNA(codReporte,idCompania,vigencia,numero,parrafo){
        return Api().get('getTNA'+'/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTNT(codReporte,idCompania,vigencia,numero,parrafo){
        return Api().get('getTNT'+'/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTNC(codReporte,idCompania,vigencia,numero,parrafo){
        return Api().get('getTNC'+'/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    grabeNotaParrafo(parrafo) {
        return Api().post('grabeNotaParrafo',parrafo)
    },
    genereEliminaciones(codReporte,vigencia,secuencia) {
        return Api().get('genereEliminaciones'+'/'+codReporte+'/'+vigencia+'/'+secuencia)
    },
    leaCompaniaUsuario(){
        return Api().get('leaCompaniaUsuario')
    },
    getIntercos(vigencia,opcion){
        return Api().get('getIntercos/'+vigencia+'/'+opcion)
    },
    getIntercosDetalle(vigencia,p_identificacion_origen,p_identificacion_destino,codReporte){
        return Api().get('getIntercosDetalle/'+vigencia+'/'+p_identificacion_origen+'/'+p_identificacion_destino+'/'+codReporte)
    },

	genereInterCompanias(vigencia,userId) {
		return Api().post('genereInterCompanias'+'/'+vigencia+'/'+userId)
	},
    getIntercosHuerfanos(vigencia) {
        return Api().get('getIntercosHuerfanos/' + vigencia)
    },

    getAjustesDetallados(codReporte, vigencia, empresas) {
        return Api().post(
            'getAjustesDetallados/' + codReporte + '/' + vigencia,
            { empresas }
        );
    },

    gestionarReportesOri(payload) {
        return Api().post('gestionarReportesOri', payload)
    },
    
    obtenerSaldosMasivosOri(idCompania, vigencia, cuentas) {
        return Api().post('obtenerSaldosMasivosOri', {
            idCompania: idCompania,
            vigencia: vigencia,
            cuentas: cuentas
        })
    },

    obtenerCuentasPorMultiplesNiif(codReporte, idCompania, vigencia, niifs) {
        return Api().post('obtener-cuentas-multiples-niif', {
            codReporte,
            idCompania,
            vigencia,
            niifs
        })
    },

    getAjustesOrigenB(codReporte, vigencia){
        return Api().get(
            'getAjustesOrigenB/' + codReporte + '/' + vigencia
        )
    },
    verificarYActualizarValoresCero(datos) {
        return Api().post('verificar-actualizar-cero', datos);
    },
    obtenerItemActualizado(params) {
        return Api().get('obtener-item-actualizado', { params: params });
    },
    guardarTablaTBM(datos) {
        return Api().post('guardarTablaTBM', datos)
    },
    getTBM(codReporte, idCompania, vigencia, numero, parrafo) {
        return Api().get('getTBM' + '/' + codReporte + '/' + idCompania + '/' + vigencia + '/' + numero + '/' + parrafo)
    },
    getAjustesTopsideMultiples(companias, vigencia, codReporte, tipo_ajuste) {
        return Api().post('getAjustesTopsideMultiples', {
            companias: companias,
            vigencia: vigencia,
            codReporte: codReporte,
            tipo_ajuste: tipo_ajuste
        })
    },
    getReporteInformacionConsolidado(idCompania, vigencia, codReporte, directo, u_crea){
        return Api().get('ReporteInformacionConsolidado/' + idCompania + '/' + vigencia + '/' + codReporte + '/' + directo + '/' + u_crea)
    },

    grabaInformacionConsolidado(idCompania, vigencia, codReporte, form){
        return Api().post('GrabaInformacionConsolidado/' + idCompania + '/' + vigencia + '/' + codReporte, form)
    },

    obtenerFilasPrincipalesOri(codReporte, idCompania, vigencia) {
        return Api().get(`obtenerFilasPrincipalesOri/${codReporte}/${idCompania}/${vigencia}`);
    },

    obtenerTotalesFilasOri(codReporte, idCompania, vigencia) {
        return Api().get(`obtenerTotalesFilasOri/${codReporte}/${idCompania}/${vigencia}`);
    },

    obtenerReporteComparativoOri(codReporte, idCompania, vigencia) {
        return Api().get(`obtenerReporteComparativoOri/${codReporte}/${idCompania}/${vigencia}`);
    },

    gestionarFilasPrincipalesOri(payload) {
        return Api().post('gestionarFilasPrincipalesOri', payload)
    },

    gestionarFormulacionesOri(payload) {
        return Api().post('gestionarFormulacionesOri', payload)
    },

    eliminarFilaPrincipalOri(id) {
        return Api().delete(`eliminarFilaPrincipalOri/${id}`)
    },

    eliminarFormulacionOri(id) {
        return Api().delete(`eliminarFormulacionOri/${id}`)
    },

    obtenerFormulacionesOri(codReporte, id_compania, vigencia, orden_fila) {
        return Api().get(`obtenerFormulacionesOri/${codReporte}/${id_compania}/${vigencia}/${orden_fila}`)
    },

    copiarConfiguracionOri(codReporte, idCompania, vigenciaOrigen, vigenciaDestino, userId) {
        return Api().post('copiarConfiguracionOri', {
            codReporte: parseInt(codReporte),
            idCompania: parseInt(idCompania),
            vigencia_origen: vigenciaOrigen,
            vigencia_destino: vigenciaDestino,
            u_crea: parseInt(userId)
        });
    },

    obtenerReporteConsolidadoOri(codReporte, empresas, vigencia) {
        return Api().get(`obtenerReporteConsolidadoOri/${codReporte}/${empresas}/${vigencia}`);
    },

}
